import { gql } from '@apollo/client';

const MONITORING_FRONTEND_ERROR_MUTATION = gql`
  mutation monitoringFrontendError($input: MonitoringFrontendErrorInput!) {
    monitoringFrontendError(input: $input) {
      isSuccess
      message
    }
  }
`;

export default MONITORING_FRONTEND_ERROR_MUTATION;
